import { ENDPIONTS, PaginatedResult } from "@api";
import { AddAllowanceType } from "@components";
import { useFetch } from "@hooks";
import { AllowanceType } from "@models";
import { Action, ComplexHeader, Table } from "@shared";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const ListAllowanceTypes = () => {
  const MySwal = withReactContent(Swal);

  const [reload, setReload] = useState<boolean | undefined>(undefined);

  const fetchAllowanceTypes = useFetch<PaginatedResult<AllowanceType>>(
    { endPoint: ENDPIONTS.allowanceTypes, reload: reload },
    new PaginatedResult<AllowanceType>()
  );

  useEffect(() => {}, [fetchAllowanceTypes?.isFetching]);

  const headers: ComplexHeader[] = [
    { key: "name", title: "Name" },
    { key: "type", title: "Type" },
    { key: "createdAt", title: "@", format: "date" },
  ];

  const actions: Action[] = [
    {
      key: "",
      actionType: "badge",
      click: (a: AllowanceType) => {
        onButtonClick(null, a);
      },
      title: "Edit",
      color: "dark",
    },
  ];

  const onButtonClick = (e: any, a?: AllowanceType) => {
    e !== null && e.preventDefault();

    MySwal.fire({
      showConfirmButton: false,
      allowOutsideClick: false,
      showCloseButton: true,
      width: 600,
      html: (
        <AddAllowanceType
          allowanceType={a}
          callback={() =>
            setReload((prev) => (prev === undefined ? true : !prev))
          }
        />
      ),
    });
  };

  return (
    <div className="col-5 d-flex">
      <div className="card profile-box flex-fill">
        <div className="card-body">
          <h3 className="card-title">
            Allowance Types
            <a
              href="!#"
              onClick={(e) => onButtonClick(e)}
              className="edit-icon"
              data-bs-toggle="modal"
              data-bs-target="#personal_info_modal"
            >
              <i className="fa fa-plus" />
            </a>
          </h3>
          <Table
            actions={actions}
            class="table table-striped table-hover mb-0"
            data={fetchAllowanceTypes?.data ?? []}
            headers={headers}
            isFetchingPage={fetchAllowanceTypes.isFetching}
            showCounter
            // onPageChange={handlePageChange}
            paginationClass="row mt-3"
          />
        </div>
      </div>
    </div>
  );
};

export default ListAllowanceTypes;
